import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { LOGO_URL } from "@/data/content";

export default function PaymentCancel() {
  return (
    <section className="min-h-[70vh] flex items-center bg-[#0A0A0A]" data-testid="payment-cancel-page">
      <div className="max-w-2xl mx-auto px-4 py-24 text-center">
        <img src={LOGO_URL} alt="Louisiana Ducks logo" className="h-24 w-24 object-contain mx-auto mb-8" />
        <XCircle size={56} className="text-gray-500 mx-auto" />
        <h1 className="font-display text-5xl uppercase text-white mt-6">Donation Cancelled</h1>
        <p className="mt-5 text-gray-300 leading-relaxed" data-testid="payment-cancel-message">
          No charge was made. Whenever you're ready, the Ducks would be grateful for your support.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/donate"
            data-testid="payment-cancel-retry-button"
            className="inline-block bg-[#FEE123] text-black text-base font-extrabold uppercase tracking-widest px-8 py-3 rounded-sm transition-transform duration-200 hover:scale-105 hover:bg-[#FFEA61]"
          >
            Try Again
          </Link>
          <Link
            to="/"
            data-testid="payment-cancel-home-link"
            className="inline-block bg-[#0F4D22] text-white text-base font-bold uppercase tracking-widest px-8 py-3 rounded-sm border border-[#FEE123]/30 transition-colors duration-200 hover:bg-[#146B2F]"
          >
            Back To Home
          </Link>
        </div>
      </div>
    </section>
  );
}
